import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Reflection } from '../models';
import { PaginationParams } from '../types';

export const reflectionsActions = createActionGroup({
    source: 'Reflections',
    events: {
        'Get Reflections': props<{ value: PaginationParams }>(),
        'Get Reflections Success': props<{ payload: Reflection[]; total: number }>(),
        'Get Reflections Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
